export default {
  SET_ACTIVE_SECTION: 'SET_ACTIVE_SECTION'
}
